<template lang="pug">
  v-layout(align-start)
    v-flex
      v-data-table.elevation-6(:headers='headers' :items='ordPendientes' :search='search' sort-by='codOrden' :footer-props="{itemsPerPageText: 'Ordenes por página'}" :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:footer.page-text='items')  {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
        template(v-slot:top)
          v-toolbar(flat color='primary' dark)
            v-toolbar-title.justify-center Ordenes Pendientes
            v-divider.mx-4(inset vertical)
            v-spacer
            v-text-field.text-xs-center.px-2(v-model='search' label='Búsqueda' single-line hide-details color='success')
            v-spacer
            v-btn.mx-2(v-if='validarCrear()' fab dark small color='success' @click='dialog = true' )
              v-icon(dark) mdi-plus
            ImportacionOrdPendientesM(:dialog='dialog' :editedIndex='editedIndex' @close='close' :read='read' :FormPadre='form'  @edited='listarOrdPendientes' @save='listarOrdPendientes')
        template(v-slot:item.action='{ item }')
          v-tooltip(bottom)
            template(v-slot:activator='{ on }')
              v-icon.mr-2(color='primary_2' @click='editedItem(item, true)' v-on="on") mdi-eye
            | Visualizar
          v-tooltip(bottom)
            template(v-slot:activator='{ on }')
              v-icon.mr-2(v-if='validarModificar()' color='warning' @click='editedItem(item, false)' v-on="on") mdi-pencil
            | Editar
          v-tooltip(bottom)
            template(v-slot:activator='{ on }')
              v-icon(v-if='validarEliminar()' color='error' @click='deleteItem(item)' v-on="on") mdi-delete
            | Eliminar
        template(v-slot:no-data)
          h1 No hay datos de Ordenes
</template>

<script>
import Api from '@/services/methods'
import ImportacionOrdPendientesM from '../components/modals/ImportacionOrdPendientesM'
export default {
  data: () => ({
    dialog: false,
    search: '',
    ordPendientes: [],
    headers: [
      { text: 'Nro. Documento', value: 'nroExpediente', align: 'center' },
      { text: 'Nro. de Contenedores', value: 'nroContenedores', align: 'center' },
      { text: 'Estimado de llegada', value: 'fechaETA2', align: 'center' },
      { text: 'Total($)', value: 'totalGeneralOrd', align: 'center' },
      { text: 'Acciones', value: 'action', align: 'center', sortable: false }
    ],
    read: false,
    permisosImportacion: {},
    form: {
      nroExpediente: 0,
      nroContenedores: 0,
      ordenes: [],
      fechaETD: '',
      fechaETA1: '',
      fechaETA2: '',
      fechaETA3: '',
      paisETD: [],
      paisETA1: [],
      paisETA2: [],
      almacenLlegada: '',
      puertoETD: null,
      puertoETA1: null,
      puertoETA2: null,
      piezasGeneralOrd: 0,
      kilogramosGeneralOrd: 0,
      piesCubicosGeneralOrd: 0,
      metroCubicoGeneralOrd: 0,
      totalGeneralOrd: 0
    },
    defaultForm: {
      nroExpediente: 0,
      nroContenedores: 0,
      ordenes: [],
      fechaETD: '',
      fechaETA1: '',
      fechaETA2: '',
      fechaETA3: '',
      paisETD: [],
      paisETA1: [],
      paisETA2: [],
      almacenLlegada: '',
      puertoETD: null,
      puertoETA1: null,
      puertoETA2: null,
      piezasGeneralOrd: 0,
      kilogramosGeneralOrd: 0,
      piesCubicosGeneralOrd: 0,
      metroCubicoGeneralOrd: 0,
      totalGeneralOrd: 0
    },
    editedIndex: -1,
    loading: true
  }),

  components: {
    ImportacionOrdPendientesM
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.permisosImportacion = this.$store.state.usuario.Empresa[0].permisos.find(permiso => permiso.ruta === 'Importacion')
      if (this.permisosImportacion) {
        this.editedIndex = -1
        this.listarOrdPendientes()
      } else {
        this.$swal({
          icon: 'error',
          title: 'Permiso Denegado',
          text: 'No tiene los pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'OK',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    },

    listarOrdPendientes () {
      Api.get('/ordPendiente')
        .then(res => {
          this.ordPendientes = res.data
          this.ordPendientes.map(data => {
            data.fechaETD ? data.fechaETD = this.formato(data.fechaETD) : data.fechaETD = ''
            data.fechaETA1 ? data.fechaETA1 = this.formato(data.fechaETA1) : data.fechaETA1 = ''
            data.fechaETA2 ? data.fechaETA2 = this.formato(data.fechaETA2) : data.fechaETA2 = ''
            data.fechaETA3 ? data.fechaETA3 = this.formato(data.fechaETA3) : data.fechaETA3 = ''
            data.ordenes.map(dataOrd => {
              dataOrd.fechaCyEOrd ? dataOrd.fechaCyEOrd = this.formato(dataOrd.fechaCyEOrd) : dataOrd.fechaCyEOrd = ''
            })
          })
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    validarCrear () {
      return this.permisosImportacion?.accion.includes('Crear')
    },
    validarModificar () {
      return this.permisosImportacion?.accion.includes('Modificar')
    },
    validarEliminar () {
      return this.permisosImportacion?.accion.includes('Eliminar')
    },

    formato (fecha) {
      return fecha.slice(0, 10)
    },

    editedItem (item, bool) {
      this.editedIndex = this.ordPendientes.indexOf(item)
      this.form = Object.assign({}, item)
      this.read = bool
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.ordPendientes.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quiere borrar?',
        text: 'No podrá revertir',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
          this.ordPendientes.splice(index, 1)
          Api.put('/ordPendiente/deletelog/' + item._id).then(response => {
          })
        }
      })
    },

    close () {
      this.dialog = false
      this.read = false
      this.editedIndex = -1
    }
  }
}
</script>

<style lang="scss">
</style>
